module.exports = __webpack_public_path__ + "img/continue.0287f29d.svg";